// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/TokensAndPots/TokenPot.css
// module id = 3072
// module chunks = 0